var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSocialVimeo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.451 15.505c0 .912-.746 1.658-1.657 1.658H2.534a1.662 1.662 0 0 1-1.658-1.658V2.245c0-.911.746-1.657 1.658-1.657h13.26c.911 0 1.657.746 1.657 1.657v13.26Z",
    fill: "#1AB7EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.827 6.099c-.055 1.16-.87 2.762-2.445 4.793-1.63 2.113-3.011 3.177-4.13 3.177-.704 0-1.284-.65-1.768-1.934-.317-1.188-.649-2.362-.967-3.55-.359-1.284-.746-1.934-1.16-1.934-.083 0-.4.194-.94.567l-.565-.732c.593-.525 1.174-1.036 1.754-1.561.787-.677 1.381-1.036 1.782-1.077.925-.083 1.505.552 1.726 1.906.235 1.478.4 2.39.483 2.748.263 1.216.567 1.837.884 1.837.25 0 .622-.4 1.133-1.187.497-.788.773-1.396.801-1.81.07-.677-.193-1.022-.8-1.022-.291 0-.581.07-.885.193.594-1.933 1.713-2.859 3.37-2.804 1.216.028 1.796.83 1.727 2.39Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.575,
    height: 16.575,
    fill: "#fff",
    transform: "translate(.876 .588)"
  })))));
};
export { SvgSocialVimeo as ReactComponent };